import React from 'react';
import { motion } from 'framer-motion';
import { UserCheck } from 'lucide-react';
export function WhoItsFor() {
  const criteria = ['schnarchen oder oft mit offenem Mund schlafen', 'morgens trocken und müde sind', 'keine Lust mehr haben, dass das Bett zum Streitpunkt wird', 'diskret zu Hause testen wollen, bevor sie "großes Programm" machen'];
  return <section className="w-full bg-[#0f172a] py-20 px-4 md:px-6 border-b border-[#334155]" data-id="element-192">
      <div className="max-w-2xl mx-auto" data-id="element-193">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-194">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-[#1e293b] rounded-full mb-6 border border-[#334155]" data-id="element-195">
            <UserCheck className="w-8 h-8 text-[#d4a574]" data-id="element-196" />
          </div>
          <h2 className="text-3xl font-bold text-[#faf5ef] mb-4" data-id="element-197">
            Für wen das ist
          </h2>
          <p className="text-xl text-[#94a3b8]" data-id="element-198">Für Männer 35+, die:</p>
        </motion.div>

        <div className="bg-[#1e293b]/30 rounded-2xl p-8 border border-[#334155]" data-id="element-199">
          <ul className="space-y-4" data-id="element-200">
            {criteria.map((item, i) => <motion.li key={i} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-center text-lg text-[#cbd5e1]" data-id="element-201">
                <span className="w-2 h-2 bg-[#d4a574] rounded-full mr-4 flex-shrink-0" data-id="element-202"></span>
                {item}
              </motion.li>)}
          </ul>
        </div>
      </div>
    </section>;
}